import * as Sentry from '@sentry/remix'
import { useEffect } from 'react'
import { useLocation, useMatches } from '@remix-run/react'

export const sentryInit = (dsn: string, environment?: string, debug?: string) =>
  Sentry.init({
    dsn: dsn,
    environment: environment ?? 'production',
    enabled: environment == 'development' ? false : true,
    debug: debug == 'true' ? true : false,
    tracesSampleRate: 0.1,
    integrations: [
      Sentry.browserTracingIntegration({
        useEffect,
        useLocation,
        useMatches,
      }),
    ],
    replaysSessionSampleRate: 0.02,
    replaysOnErrorSampleRate: 0.5,
  })
